import ProjectCore, { IProject } from "./ProjectCore";

export interface IProjectLiabilityFull extends IProject {}

export default class ProjectLiabilityFull extends ProjectCore {
  constructor(dto: IProjectLiabilityFull) {
    super(dto);
  }
}
